import React, { Suspense } from "react";
import Routes from "./Route/Routes";


function App() {
  

  return (
    <Suspense fallback={null}>
      <Routes />
    </Suspense>
  
  );
}

export default App;
